import { colors } from '../../colors';
var input = {
  textColor: colors.darkNight
};
export default input;